import React, { useState, useEffect, useCallback } from 'react';
import useOrder from '../../hooks/useOrder';
import debounce from 'lodash.debounce';
import swal from 'sweetalert';

const OrderCard = ({
  id,
  name,
  image,
  quantity,
  price,
  originalPrice,
  promoPercentage,
  isSelected,
  onSelect,
}) => {
  const { removeProduct, updateQtyDirect } = useOrder();
  const [localQty, setLocalQty] = useState(quantity);

  useEffect(() => {
    setLocalQty(quantity);
  }, [quantity]);

  const debouncedUpdateQty = useCallback(
    debounce((newQty) => {
      updateQtyDirect(id, newQty);
    }, 500),
    [id]
  );

  const handleQtyChange = (change) => {
    const newQty = localQty + change;
    if (newQty <= 0) {
      removeProduct(id);
      return;
    }
    setLocalQty(newQty);
    debouncedUpdateQty(newQty);
  };

  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center rounded-lg shadow px-4 py-4 bg-paragaiaLight relative overflow-hidden gap-4">
      <div className="flex items-start sm:items-center gap-4 relative w-full">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onSelect(id)}
          className="accent-customPink mt-1"
        />

        <div className="relative w-24 h-24 flex-shrink-0">
          <img src={image} alt={name} className="w-full h-full object-cover rounded" />
          {promoPercentage && (
            <span className="absolute top-0 left-0 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-br-lg shadow">
              -{promoPercentage}%
            </span>
          )}
        </div>

        <div className="flex flex-col justify-center">
          <h2 className="text-base sm:text-lg font-semibold text-customPink break-words max-w-[180px]">
            {name}
          </h2>
          <div className="text-sm mt-1">
            {originalPrice ? (
              <div className="flex items-center space-x-2">
                <span className="text-gray-500 line-through">{originalPrice} TND</span>
                <span className="text-customPink font-bold">{price.toFixed(2)} TND</span>
              </div>
            ) : (
              <span className="text-customPink font-bold">{price.toFixed(2)} TND</span>
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-between sm:justify-end items-center gap-2 mt-2 sm:mt-0 flex-wrap sm:flex-nowrap">
        <div className="flex items-center gap-2">
          <button
            onClick={() => handleQtyChange(-1)}
            className="bg-white border border-customPink text-customPink px-2 rounded text-sm"
          >
            −
          </button>
          <span className="text-lg font-semibold">{localQty}</span>
          <button
            onClick={() => handleQtyChange(1)}
            className="bg-white border border-customPink text-customPink px-2 rounded text-sm"
          >
            +
          </button>
        </div>

        <button
          onClick={() => {
            swal({
              title: 'Êtes-vous sûr ?',
              text: 'Ce produit sera supprimé de votre panier.',
              icon: 'warning',
              buttons: ['Annuler', 'Supprimer'],
              dangerMode: true,
            }).then((willDelete) => {
              if (willDelete) {
                removeProduct(id);
                swal('✅ Supprimé', 'Le produit a été retiré du panier.', 'success');
              }
            });
          }}
          className="text-red-500 text-sm sm:text-base"
        >
          Supprimer
        </button>

      </div>
    </div>
  );
};

export default OrderCard;
